export const enum LEADERBOARD_TAB {
  team = 'team',
  section = 'section',
  challenge = 'challenge',
  championship = 'championship',
}
